import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import WmsMobileLayout from "../../wmsMobileLayout";
import PageTitle from "../../../../components/WMS/Mobile/PageTitle";
import {FormattedMessage} from "react-intl";
import CustomButton from "../../../../components/CustomButton";
import {WMSRoutes} from "../../../../utils/WMSRoutes";
import {Card, CardContent, Grid, Paper, Table, TableBody, TableContainer} from "@mui/material";
import Header from "./Header";
import ModelItem from "./ModelItem";
import {MissionModelListContext} from "../MissionModelListContext";

function ModelListMobile() {
    const {missionModels, history} = useContext(MissionModelListContext)

    const vhToPx = (vh) => {
        return (window.innerHeight * vh) / 100
    }

    return (
        <WmsMobileLayout>
            <WmsMobileLayout.Content>
                <Grid
                    container
                    direction={'column'}
                >
                    <PageTitle
                        title={<FormattedMessage id={"wms.pickingMissionList.title"}/>}
                        subtitle={<FormattedMessage id={"wms.pickingMissionList.subtitle"}/>}
                    />

                    <Grid item sx={{marginLeft: 'auto', padding: "12px 16px"}}>
                        <CustomButton thicker onClick={() => history.push(`${WMSRoutes.NEW_MISSION}`)}>
                            <FormattedMessage id={"wms.pickingMissionList.redirectButton.newModel"}/>
                        </CustomButton>
                    </Grid>
                </Grid>

                <Card>
                    <CardContent>
                        <Paper sx={{width: '100%', overflow: 'hidden'}}>
                            <TableContainer sx={{maxHeight: vhToPx(55)}}>
                                <Table stickyHeader>
                                    <Header/>
                                    <TableBody>
                                        {missionModels.length > 0 && missionModels.map((missionModel) => {
                                            return (
                                                <ModelItem
                                                    key={missionModel.id}
                                                    missionModel={missionModel}
                                                />
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </CardContent>
                </Card>
            </WmsMobileLayout.Content>
        </WmsMobileLayout>
    );
}

export default ModelListMobile;